<template>
  <div class="van-hairline--bottom">
    <slot></slot>
    <!--<div class="error" v-if="errors()"><span class="icon icon-note"></span>{{validationErrors}}-->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      //      validationErrors: null,
      //      modelExpression: this.$options._parentVnode.data.model.expression
    }
  },
  props: {
    //    value: {
    //      type: String
    //    }
  },
  //  inject: ['$validation'],
  methods: {
    errors () {
      //      this.validationErrors = this.$validation.error(this.modelExpression)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.van-hairline--bottom /deep/ {
  .error {
    color: $assertive;
    padding: 5px 10px 0;
    margin-left: 2.4rem;
    font-size: 12px;
    display: flex;
    align-items: center;
    span {
      margin-right: 5px;
    }
  }
  > div:last-child {
    padding-bottom: 15px;
  }
  .van-cell {
    padding-bottom: 0;
    &:after {
      display: none;
    }
  }
}
</style>
